"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Component = exports.Comments = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _i18n = require("../../utils/i18n");
var _commentList = _interopRequireDefault(require("./components/comment-list"));
var _commentForm = _interopRequireDefault(require("./components/comment-form"));
var _comment = _interopRequireDefault(require("./icons/comment"));
var _commentService = require("./components/comment-service");
var _utils = require("./components/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var PAGE_SIZE = 3;
var Comments = exports.Comments = function (_React$Component) {
  function Comments(props) {
    var _this;
    _classCallCheck(this, Comments);
    _this = _callSuper(this, Comments, [props]);
    _this.state = {
      comments: [],
      showCommentForm: false,
      page: 1
    };
    _this._toggleCommentForm = _this._toggleCommentForm.bind(_this);
    _this._updateCommentList = _this._updateCommentList.bind(_this);
    _this._refreshCommentsList = _this._refreshCommentsList.bind(_this);
    return _this;
  }
  _inherits(Comments, _React$Component);
  return _createClass(Comments, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._refreshCommentsList();
    }
  }, {
    key: "getCommentsList",
    value: function getCommentsList(comments) {
      if (comments && comments.length) {
        return _react.default.createElement(_commentList.default, {
          displayName: this.props.displayName,
          contentKey: this.props.contentKey,
          siteKey: this.props.siteKey,
          endpoint: this.props.endpoint,
          comments: comments,
          titleType: (0, _i18n.translate)('comments.comment'),
          refreshCommentList: this._refreshCommentsList,
          url: this.props.url
        });
      }
      return null;
    }
  }, {
    key: "getCommentsForm",
    value: function getCommentsForm() {
      if (this.state.showCommentForm) {
        return _react.default.createElement(_commentForm.default, {
          contentKey: this.props.contentKey,
          displayName: this.props.displayName,
          siteKey: this.props.siteKey,
          endpoint: this.props.endpoint,
          toggleCommentForm: this._toggleCommentForm,
          refreshCommentList: this._refreshCommentsList,
          url: this.props.url
        });
      }
      return _react.default.createElement("button", {
        className: "handle-commentForm",
        onClick: this._toggleCommentForm
      }, _react.default.createElement(_comment.default, null), "\xA0 ", (0, _i18n.translate)('comments.addCommentButtonText'));
    }
  }, {
    key: "_refreshCommentsList",
    value: function _refreshCommentsList() {
      var _this2 = this;
      (0, _commentService.getComments)(this.props.contentKey, this.props.siteKey, this.props.endpoint).then(function (data) {
        return _this2.setState({
          comments: data.map(function (comment) {
            return (0, _utils.getCommentAndReplies)(comment);
          })
        });
      });
    }
  }, {
    key: "_getShowMoreCommentsButton",
    value: function _getShowMoreCommentsButton() {
      if (this.state.comments.length <= this.state.page * PAGE_SIZE) {
        return null;
      }
      return _react.default.createElement("button", {
        className: "handle-commentForm",
        onClick: this._updateCommentList
      }, " ", (0, _i18n.translate)('comments.showMore'));
    }
  }, {
    key: "_updateCommentList",
    value: function _updateCommentList() {
      this.setState({
        page: this.state.page + 1
      });
    }
  }, {
    key: "_toggleCommentForm",
    value: function _toggleCommentForm() {
      this.setState({
        showCommentForm: !this.state.showCommentForm
      });
    }
  }, {
    key: "render",
    value: function render() {
      var comments = this.state.comments.slice(0, this.state.page * PAGE_SIZE);
      return _react.default.createElement("section", {
        className: "o-comments",
        id: "comments",
        itemScope: true,
        itemType: "http://schema.org/UserComments"
      }, _react.default.createElement("h3", null, (0, _i18n.translate)('comments.heading')), this.getCommentsForm(), this.getCommentsList(comments), this._getShowMoreCommentsButton());
    }
  }]);
}(_react.default.Component);
Comments.propTypes = {
  endpoint: _propTypes.default.string.isRequired,
  siteKey: _propTypes.default.string.isRequired,
  contentKey: _propTypes.default.string.isRequired,
  displayName: _propTypes.default.string,
  url: _propTypes.default.string
};
var Component = exports.Component = Comments;
var _default = exports.default = {
  Component: Component
};